import { Component  } from "react";
import {ModalBody} from 'reactstrap'
import SubscribeForm from "../Components/SubscribeForm/SubscribeForm";
import {globals} from "../Components/Globals/Globals"

class SubscribeView extends Component{
    constructor(props){
        super(props)
    }

    render(){
        return(<div className="subscribe-page-container">
                {/* Full width main picture */}
                <div className="top-banner-image">
                    <div className="nested-title">{globals.menu.subscribe}</div>
                </div>
                <div className="body-page-container">
                    {/* Laïus introduction de la page*/}
                    <div className="welcome-title">
                        <div>
                            Vous souhaitez être informés de l'avancement de nos projets ? devenez adhérant de la mission...
                        </div>
                    </div>
                    <ModalBody>
                        <SubscribeForm/>  
                    </ModalBody>
                </div>
            </div>)
    }
}

export default SubscribeView;